import { FetchResult, withFetchErrorHandling } from "./resourceTypes";

/**
 * Fetches a URL and returns its text content.
 * Captures errors to telemetry with rich context.
 *
 * @param url - The URL to fetch
 * @param init - Optional fetch init options
 * @returns FetchResult containing either the text content or an error
 */
export async function fetchText(url: string, init?: RequestInit): Promise<FetchResult<string>> {
  return withFetchErrorHandling(url, "fetchText", (response) => response.text(), init);
}
